"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var MuiAutocomplete = function MuiAutocomplete(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      '& [class*="MuiInputLabel-outlined"][class*="MuiInputLabel-shrink"]': {
        transform: 'translate(24px, -16px) scale(0.75)'
      }
    },

    /* Styles applied to the Input element. */
    inputRoot: {
      '& $tag:first-child': {
        marginLeft: 0
      },
      '&[class*="MuiOutlinedInput-root"]': {
        padding: '5px 24px',
        '& $input:first-child': {
          paddingLeft: 0
        }
      },
      '&[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
        padding: '2px 24px',
        '& $input:first-child': {
          paddingLeft: 0
        }
      }
    },

    /* Styles applied to the option elements. */
    option: {
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingTop: 0,
      '&[aria-selected="true"]': {
        backgroundColor: theme.palette.action.selected,
        '&:hover': {
          backgroundColor: theme.palette.action.selected
        },
        '& svg': {
          color: theme.palette.success.main
        }
      },
      '&[data-focus="true"]': {
        backgroundColor: theme.palette.action.selected,
        color: theme.palette.primary.main,
        '& svg': {
          color: theme.palette.action.focus
        }
      },
      '&:active': {
        backgroundColor: theme.palette.action.selected,
        '& svg': {
          color: theme.palette.action.active
        }
      },
      '&[aria-disabled="true"]': {
        opacity: theme.palette.action.disabledOpacity,
        pointerEvents: 'none',
        '& svg': {
          color: theme.palette.action.disabled
        }
      }
    }
  };
};

var _default = MuiAutocomplete;
exports["default"] = _default;